module.exports = __webpack_public_path__ + "assets/img/shouquan.bfefaa4f.png";